/**
 * Global Error Handler for Authentication
 * Handles authentication errors and session expired scenarios
 */

import { identityAuth } from './IdentityAuth';

// Global reference to the current IdentityAuthProvider instance
let authProviderInstance = null;

// Set the auth provider instance (called from IdentityAuthProvider)
export const setAuthProviderInstance = instance => {
  authProviderInstance = instance;
};

// Handle authentication errors globally
export const handleAuthError = error => {
  // Check if error indicates session expired or authentication failure
  const isAuthError =
    error &&
    // Check if it's marked as auth error
    (error.isAuthError === true ||
      // Check response data
      (error.response &&
        error.response.data &&
        ((typeof error.response.data === 'string' &&
          error.response.data.includes('Session expired')) ||
          (typeof error.response.data === 'object' &&
            error.response.data.error &&
            error.response.data.error.includes('Session expired')))) ||
      // Check status codes
      (error.response &&
        (error.response.status === 401 || error.response.status === 403)) ||
      // Check error message
      (error.message && error.message.includes('Session expired')));

  if (isAuthError) {
    if (authProviderInstance && authProviderInstance.handleSessionExpired) {
      // Use the IdentityAuthProvider to handle the session expired
      authProviderInstance.handleSessionExpired();
    } else {
      identityAuth.redirectToLogin();
    }

    return true; // Error was handled
  }

  return false; // Error was not an auth error
};

// Hook for components to use
export const useAuthErrorHandler = () => {
  return {
    handleAuthError: error => handleAuthError(error),
  };
};
